import React from 'react';

export default class DateDataType extends React.Component {
	render() {
		const { value } = this.props;

		if (value === null || value === undefined) {
			return <span>-</span>;
		}

		// Parse input string into a Date object (considering UTC time zone)
		const parsedDateUTC = new Date(value);

		// Check if the parsed date is invalid
		if (isNaN(parsedDateUTC.getTime())) {
			return <span>Invalid Date</span>;
		}

		// Adjust date to local time zone
		const localDate = new Date(
			parsedDateUTC.getTime() + parsedDateUTC.getTimezoneOffset() * 60000
		);

		// Format the date as needed (e.g., MM/DD/YYYY)
		const formattedDate = `${localDate.getMonth() +
			1}/${localDate.getDate()}/${localDate.getFullYear()}`;

		return <span>{formattedDate}</span>;
	}
}
